export default __webpack_public_path__ + "c8852085b1ce9a29d8fdceb85954c219.json";